import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { memo, useMemo } from "react";
import { styled } from "@mui/material";
import MxMapViewer from "@rf-l1/map-v2/components/MxMapViewer";
const containerStyle = {
  width: "100%",
  height: "300px"
};

const LocationMap = () => {
  const {
    PROPERTY_DETAIL: { principalData }
  } = useRealEstateDetailContext();

  const marker = useMemo(() => {
    if (principalData.latitude && principalData.longitude) {
      return {
        lat: Number(principalData.latitude),
        lng: Number(principalData.longitude)
      };
    }
    return undefined;
  }, [principalData.longitude, principalData.latitude]);

  return (
    <Container>
      <MxMapViewer
        lat={marker?.lat ?? 0}
        lng={marker?.lng ?? 0}
        disabled={true}
        zoom={15}
      />
    </Container>
  );
};

export default memo(LocationMap, () => true);

const Container = styled("div")(({ theme }) => ({
  ".container-map": {
    borderRadius: "20px",
    padding: "10px"
  },
  display: "flex",
  flexDirection: "column",
  gap: "20px"
}));
